import styles from "../css/reverseStock.module.css";
import FilterButtons from "../../../../components/universal-filter-tabs.jsx";

export default function Header({ roleId, activeSegment, onSegmentChange, mode, setMode }) {
  return (
    <div className={styles.headerRow}>
      <h1 className={styles.title}>Reverse Stock</h1>
      {roleId !== 6 && (
        <div className={styles.tabsRow}>
          <FilterButtons
            buttons={["Dispensary", "Front Shop", "OTC"]}
            activeButton={activeSegment}
            onButtonClick={onSegmentChange}
            className={styles.segmentTabs}
          />
        </div>
      )}
      <div className={styles.statusTabs}>
        <FilterButtons
          buttons={["Pending", "NCND"]}
          activeButton={(mode === "history" || mode === "historyDetails") ? "NCND" : "Pending"}
          onButtonClick={(val) => setMode(val === "NCND" ? "history" : "list")}
          className={styles.segmentTabs}
        />
      </div>
    </div>
  );
}
